import AnimationController from './animation';
import ScrollController from './scroll';

import Modals from '../../../modals';

import { classesActiveAndIn, classesDelayedOut } from '../helpers';

class ModalController {

	types = ['modals'];

	modals = Modals;

	//

	el = {};

	pages = {};

	states = {
		activeId: null
	};

	initialize(slug = 'default', scope = document.documentElement.querySelector('#modals-wrapper')) {
		this.el = {
			scope
		};

		if (!this.pages[slug]) this.pages[slug] = [];
		for (const type of this.types) {
			for (const selector in this[type]) {
				const els = ['[', '.', '#'].indexOf(selector.charAt(0)) === 0 ? scope.querySelectorAll(`${selector}`) : scope.querySelectorAll(`.${selector}`);
				for (const el of els) {
					this.pages[slug].push(new this[type][selector](el, slug));
				}
			}
		}
	}

	//

	open(id, slug = 'default') {
		const pageModals = this.pages[slug];

		if (id !== this.states.activeId) {
			for (let i = 0; i < pageModals.length; i++) {
				const pageModal = pageModals[i];
				if (typeof (pageModal.id) === 'undefined') {
					console.error('Modal is missing required id property!');
				} else if (pageModal.id === id) {
					this.states.activeId = id;
					this.wrapperShow();
					pageModal.open();
				}
			}
		}
	}

	close(id = null, slug = 'default') {
		const modalId = id || this.states.activeId;
		const pageModals = this.pages[slug];

		for (let i = 0; i < pageModals.length; i++) {
			const pageModal = pageModals[i];
			if (typeof (pageModal.id) === 'undefined') {
				console.error('Modal is missing required id property!');
			} else if (pageModal.id === modalId) {
				pageModal.close();
				this.wrapperHide();
			}
		}

		this.states.activeId = null;
	}

	//

	wrapperShow() {
		classesActiveAndIn(this.el.scope);
		ScrollController.lock();
	}

	wrapperHide() {
		ScrollController.unlock();
		classesDelayedOut(this.el.scope, 300);
	}

	//

	closeAll(slug = 'default') {
		const pageModals = this.pages[slug];
		for (let i = 0; i < pageModals.length; i++) {
			const pageModal = pageModals[i];
			pageModal.close();
		}

		classesDelayedOut(this.el.scope, 300);
		this.states.activeId = null;
	}

	//

	destroy(slug) {
		if (this.pages[slug]) {
			for (const m of this.pages[slug]) {
				if (m.destroy) {
					m.destroy();
				} else {
					console.warn('Missing destroy function!', m); // eslint-disable-line no-console
				}
			}
			delete this.pages[slug];
		}
	}

}

export default new ModalController();
